module.exports = __webpack_public_path__ + "img/andrin_thunersee_surfen_ocular.5876cf25.jpg";